import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IState {
  lead_uid?: string
  drop_off?: string
  crm_lead?: string
  crm_product: '' | 'LIFE' | 'HEALTH' | 'MOTOR' | 'BGR' | 'FIRE' | 'TRAVEL' | 'GROUP'
}

const initialState: IState = {
  crm_product: '',
}

const leadDetails = createSlice({
  name: 'leadDetails',
  initialState: initialState,
  reducers: {
    updateLeadID: (
      state,
      action: PayloadAction<{
        lead_uid: string
      }>,
    ) => {
      const { lead_uid } = action.payload
      state.lead_uid = lead_uid
    },
    updateDropOff: (
      state,
      action: PayloadAction<{
        drop_off: string
      }>,
    ) => {
      const { drop_off } = action.payload
      state.drop_off = drop_off
    },
    updateCrmLead: (
      state,
      action: PayloadAction<{
        crm_lead: string
      }>,
    ) => {
      const { crm_lead } = action.payload
      state.crm_lead = crm_lead
    },
    updateCrmProduct: (
      state,
      action: PayloadAction<'' | 'LIFE' | 'HEALTH' | 'MOTOR' | 'BGR' | 'FIRE' | 'TRAVEL' | 'GROUP'>,
    ) => {
      state.crm_product = action.payload
    },
    resetLeadDetails: () => initialState,
  },
})

const { reducer } = leadDetails

const { updateDropOff, updateLeadID, updateCrmProduct, resetLeadDetails, updateCrmLead } =
  leadDetails.actions

export {
  updateDropOff,
  updateCrmLead,
  updateLeadID,
  updateCrmProduct,
  resetLeadDetails,
  reducer as leadDetailsReducer,
}
